module.exports = __webpack_public_path__ + "static/img/platform-group2.c329f705.png";